import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import TasksFilters from 'constants/tasks';
import { Autocomplete } from 'components/FormFields';
import { generateFilterOptions } from 'utils';

const TasksStatusesSelect = ({
  label,
  variant,
  field: { name, value },
  margin,
  form: { errors, touched, setFieldValue },
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = TasksFilters.statuses.find((status) => {
        return status.value === value;
      });

      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      fullwidth="true"
      filterOptions={filterOptions}
      variant={variant}
      id="taskStatuses"
      value={defaultValue}
      options={TasksFilters.statuses}
      error={errors && errors[name] && touched && touched[name]}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      getOptionSelected={(option, value) => option.value === (value?.value || value) || ''}
      helperText={errors && errors[name] && touched && touched[name] && errors[name]}
      getOptionLabel={(option) => (option?.value ? i18n.t(`tasks_statuses.${option.value}`) : '')}
    />
  );
};

TasksStatusesSelect.propTypes = {
  loading: PropTypes.bool,
  label: PropTypes.string,
  margin: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

TasksStatusesSelect.defaultProps = {
  loading: false,
  required: true,
  disabled: false,
  margin: 'normal',
  form: {
    errors: {},
    touched: {},
  },
  variant: 'standard',
  placeholder: 'Select...',
};

export default TasksStatusesSelect;
